<template>
  <div>
  <nav class="nav-upper" v-bind:class="{'active': toggleSearch}">
    <div class="container-fluid">
      <div class="navbar">
        <router-link to="/" class="nav-logo d-flex align-items-center">
          <img :src="logo.logo" class="img-fluid" alt="" />
          <div class="logo-title white-color">
            Global Institute of Tourism and Hospitality
          </div>
          <div class="logo-title white-color logo-title-cp">
            GITH
          </div>
          <!-- <div class="logo-title" v-html="logo.title"></div> -->
        </router-link>

        <div class="nav-tools">
          <button v-if="authenticated"
              type="button"
              name="button"
              class="navbar-action"
              data-toggle="dropdown">
            <div class="showDropdown">
                <img :src="(avatar) ? avatar : require('../assets/img/avatar.jpg')" 
                    alt="" 
                    class="img-fluid" 
                    style="width:38px;height:38px;border-radius: 50%;">
                <div class="dropdown-menu">
                  <router-link to="/me/profile" class="dropdown-item">Profile</router-link>
                  <a href="javascript:;" class="dropdown-item" @click="logout()">Logout</a>
                </div>
            </div>
          </button>
          
          <router-link to="/login" v-if="!authenticated" class="nav-su">
            <span class="icon-user icon"></span>
          </router-link>
          <span class="ml-2 mr-2 vertical-line">|</span>
          <button  @click="toggleSearch = !toggleSearch" class="nav-su">
            <span v-if="!toggleSearch" class="icon-search icon"></span>
            <span v-else class="icon-cancel icon"></span>
          </button>
          <div @click="toggleMenu = !toggleMenu" id="menuBtn" class="menu-btn ml-3">
            <span class="top-bar"></span>
            <span class="middle-bar"></span>
            <span class="bottom-bar"></span>
            <div class="menu-text">Menu</div>
          </div>
        </div>
        <!-- <div class="nav-links" v-if="toggleMenu">
          <router-link v-if="(header[0]) ? header[0].status : false" 
                      to="/accreditations" class="nav-link">Accreditation</router-link>

          <router-link v-if="(header[1]) ? header[1].status : false" 
                      to="/programs" class="nav-link">Programs</router-link>

          <router-link v-if="(header[8]) ? header[8].status : false"
                      to="/our-certificates" class="nav-link">Certification</router-link>

          <router-link v-if="(header[2]) ? header[2].status : false" 
                      to="/memberships" class="nav-link">Membership</router-link>

          <router-link v-if="(header[3]) ? header[3].status : false" 
                      to="/about" class="nav-link">About</router-link>

          <router-link v-if="(header[4]) ? header[4].status : false" 
                      to="/contact" class="nav-link">Contact Us</router-link>
          <a href="javascript:;" 
            @click="opnPopular(nav.slug)" class="nav-link hidden-links" v-for="(nav, index) in popularSearch" :key="index">
            {{ nav.title }}
          </a>

            <router-link v-for="(pg, idy) in pages" :key="'p'+idy"
                      :to="{ name: 'show-page', params:{slug: pg.slug}}" 
                  class="nav-link"
                  :class="(pg.has_header) ? '' : 'hidden' ">
                  {{ pg.title }}
            </router-link>
        </div> -->
      </div>
    </div>
  </nav>

  <!-- Navbar Links -->
  <div class="navbar-container" v-bind:class="{'active': toggleMenu}">
    <div class="navbar-backdrop" v-bind:class="{'active': toggleMenu}"></div>
    <div class="navbar-content">
      <nav>
        <div class="container-fluid">
          <div class="navbar">
            <router-link to="/" class="nav-logo d-flex align-items-center">
              <!-- <img :src="require('../assets/logo.png')" class="img-fluid" alt="" /> -->
              <img :src="logo.logo" class="img-fluid" alt="" />
              <div class="logo-title white-color">
                Global Institute of Tourism and Hospitality
              </div>
              <div class="logo-title white-color logo-title-cp">
                GITH
              </div>
              <!-- <div class="logo-title" v-html="logo.title"></div> -->
            </router-link>
            <button @click="toggleMenu = false" class="close-navbar d-flex align-items-center white-color"><span class="icon-cancel mr-3"></span> <span class="cm-text">Close Menu</span></button>
          </div>
        </div>
      </nav>

      <!-- <div class="navbar-header d-flex justify-content-between align-items-center">
        <div class="nav-logo">
          <router-link :to="{ name: 'home' }"><img src="../assets/logo.png" class="img-fluid" alt="Logo" />  <span class="ml-2">ASPE</span></router-link>
        </div>
        <button id="closeNavbar" @click="closeMenu()" class="close-navbar d-flex align-items-center white-color"><span class="icon-cancel mr-3"></span> <span class="cm-text">Close Menu</span></button>
      </div> -->

      <div class="navbar-body">
        <div class="navbar-body-content container-fluid d-flex justify-content-between">
            <div class="nb-links">
              <div>
                  <router-link v-if="(header[0]) ? header[0].status : false" 
                      to="/accreditations" class="nv-link">Accreditation</router-link>
              </div>
              <div>
                  <router-link v-if="(header[1]) ? header[1].status : false" 
                      to="/programs" class="nv-link">Programs</router-link>
              </div>
              <div>
                  <router-link v-if="(header[2]) ? header[2].status : false" 
                      to="/memberships" class="nv-link">Membership</router-link>
              </div>
              <div>
                  <router-link v-if="(header[3]) ? header[3].status : false" 
                      to="/about" class="nv-link">About</router-link>
              </div>
              <div>
                  <router-link v-if="(header[4]) ? header[4].status : false" 
                      to="/contact" class="nv-link">Contact Us</router-link>
              </div>
              <div>
                  <router-link v-if="(header[5]) ? header[5].status : false" 
                      to="/our-certificates" class="nv-link">Certification</router-link>
              </div>
              <div>
                  <router-link v-for="(pg, idy) in pages" :key="'p'+idy"
                            :to="{ name: 'show-page', params:{slug: pg.slug}}" 
                      class="nv-link"
                      :class="pg.has_footer ? '' : 'hidden'">
                      {{ pg.title }}
                  </router-link>
              </div>
            </div>

            <div class="nb-top-links">
              <div class="nb-border-left">
                <div class="sm-title mb-3 white-color">Top Links</div>
                <div class="top-links">
                  <a href="javascript:;" 
                    @click="opnPopular(nav.slug)" class="tp-links"  v-for="(nav, index) in popularSearch" :key="index">
                    {{ nav.title }}
                  </a>
                </div>
                <div class="nb-view mt-5">
                  <img :src="logo.top_links ? logo.top_links : require('../assets/img/home.png')" class="img-fluid" alt="" />
                </div>
              </div>
            </div>
          </div>
      </div>

      <div class="navbar-footer">
        <div class="white-color container-fluid">
          2021 All Rights Reserved  © GITH Global Institute of Tourism and Hospitality
          <router-link class="nf-link white-color"
              v-if="(header[5]) ? header[5].status : false"
              to="/privacy"> Privacy Policy
          </router-link>
          
        </div>
      </div>
    </div>
  </div>
  <!-- Navbar Links -->

  <SearchPopup v-if="toggleSearch" />
  </div>
</template>


<style scoped="">
/* .hidden { display: none !important } */
.dropdown-menu {
  left: auto;
  right: 0;
}
.logo-title-cp {
  display: none;
}
nav {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 23;
  padding: 13px 0;
}
nav.active {
  background: #fff;
}
nav.active *,
nav.active *:before {
  color: #001157 !important;
}
nav.active .menu-btn span {
  background: #001157 !important;
}
.navbar {
  display: flex;
  align-items: center;
  padding: 0;
  justify-content: space-between;
}
.nav-links {
  display: flex;
}
.nav-link {
  color: #ffffff;
  font-size: 20px
}
.nav-link:hover {
  color: #cecece
}
.nav-tools {
  display: flex;
  align-items: center;
  margin-left: 40px;
}
.nav-tools .icon:before,
.nav-tools span {
  color: #fff;
  font-size: 20px;
}
.nav-logo {
  width: 325px;
}
.nav-logo img {
  width: 105px;
}
.logo-title {
  font-weight: bold;
  font-size: 25px;
  line-height: 1;
}
.vertical-line {
  color: #fff;
  font-size: 18px;
}
.nav-su {
  display: flex;
}
.nav-links {
  display: block;
  position: fixed;
  top: 68px;
  left: 0;
  width: 100%;
  height: calc(100% - 68px);
  z-index: 19;
  padding: 0 15px;
  border-top: 1px solid #afafaf;
  background: #00166F;
}
.nav-links .nav-link {
  padding-left: 0;
  padding-right: 0;
  font-size: 32px;
  border-bottom: 1px solid #afafaf;
}
.nav-su .icon {
  padding: 3px 3px;
}

/* Navbar Links */
.navbar-container {
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  /* background: #2D2E76; */
  z-index: -1000;
  opacity: 0;
}
.navbar-container nav {
  position: static;
}
.navbar-container.active {
  z-index: 1000;
  opacity: 1;
}
.navbar-backdrop {
  position: absolute;
  left: 0;
  top: 0;
  width: 0;
  height: 100%;
  background: radial-gradient(
    circle at 0% 0%,
    rgb(0, 67, 122) 0%,
    #2D2E76 100%
  );
  /* z-index: 1000000; */
}
.navbar-backdrop.active {
  width: 100%;
}
.navbar-content {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.navbar-header {
  padding: 30px 70px;
}
.navbar-body {
  height: calc(100% - 197px);
  overflow-y: auto;
  padding: 40px 0;
}
.close-navbar:hover span {
  color: rgb(76, 199, 244);
}
.navbar-header .icon-cancel {
  font-weight: 600;
  font-size: 19px;
}
.cm-text {
  font-size: 13px;
}
.nv-link {
  display: inline-block;
  color: #fff !important;
  padding: 2px 14px;
  font-size: 40px;
  border: 1px solid transparent;
  margin-left: -14px;
}
.nv-link:active {
  border: 1px solid rgb(76, 199, 244);
}
.nv-link:hover {
  color: rgb(76, 199, 244) !important;
}
.nb-top-links .sm-title {
  font-weight: bold;
}
.top-links .tp-links {
  display: block;
  color: #fff;
  font-size: 22px;
  margin-bottom: 5px;
  letter-spacing: 1px;
}
.nb-border-left {
  border-left: 1px solid #fff;
  padding-left: 70px;
}
.nb-view img {
  width: 370px;
  height: 192px;
  object-fit: cover;
}
.nb-view .title {
  line-height: 1;
}
.nf-link:hover {
  color: rgb(76, 199, 244) !important;
}
.nf-link {
  display: inline-block;
  line-height: 1;
  font-size: 13px;
  text-decoration: underline !important;
  font-weight: 500;
  color: #fff;
  border-right: 2px solid #fff;
  padding-right: 10px;
  margin-right: 10px;
}
.nf-link:last-of-type {
  border: none;
  padding: 0;
  margin: 0;
}
.navbar-footer {
  line-height: 1;
  padding-top: 20px;
  font-size: 15px;
  padding-bottom: 20px;
  padding-left: 0;
  padding-right: 0;
}
/* Navbar Links */


/* Extra small devices (portrait phones, less than 576px) */
@media (max-width: 575.98px) {

}

@media (max-width: 767.98px) {
  nav {
    padding: 12px 0;
  }
  .nav-logo {
    width: 88px;
  }
  .logo-title {
    display: none;
  }
  div.logo-title-cp {
    display: block !important;
  }

  /* Navbar Links */
  .navbar-body-content {
    display: block !important;
  }
  .nb-border-left {
    padding-left: 0;
    border: none;
  }
  .nb-links {
    margin-bottom: 50px;
  }
  .nv-link {
    padding: 2px 11px;
    margin-left: -11px;
  }
  .navbar-header {
    padding: 30px 40px;
  }
  .nb-view img {
    width: auto;
    height: auto;
  }
  .navbar-body {
    height: calc(100% - 178px);
    padding: 0 0 15px;
  }
  /* .hidden {
    display: block !important;
  } */
  /* Navbar Links */
}

@media (max-width: 991.98px) {
  
}

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) and (max-width: 767.98px) {
  
}

/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) and (max-width: 991.98px) {
  /* Navbar Links */
  .nb-view img {
    width: 280px;
  }
  .nb-border-left {
    padding-left: 40px;
  }
  /* Navbar Links */
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) and (max-width: 1199.98px) {
  
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {

}
</style>

<script>
import axios from "axios";
import SearchPopup from './SearchPopup';

export default {
  name: "Navbar",
  props: ['close'],
  components: {
    SearchPopup
  },
  data() {
    return {
      pgLoading: false,
      logo: [],
      header: [],
      pages: [],
      socials: [],
      searchPage: false,
      avatar: '',
      authenticated: false,
      toggleSearch: false,
      popularSearch: [],
      toggleMenu: false
    };
  },
  created() {

    // if (event.keyCode === 27) {
    //   this.toggleMenu = false;
    //   // console.log('esc key pressed');
    // }

    axios
        .get(window.baseURL + "/popularSearch")
        .then((res) => {
          const data = res;
          this.popularSearch = res.data.rows;
          console.log(data.data);
        })
        .catch(() => { });

    if (this.$route.path == '/search') {
      this.searchPage = true;
    } else {
      this.searchPage = false;
    }
    
    if (!localStorage.getItem("access_token")) {
      this.authenticated = false;
    } else {
      this.authenticated = true;
    }

    if(!localStorage.getItem("avatar")) {
      this.avatar = false;
    } else {
      this.avatar = localStorage.getItem("avatar");
    }

    this.fetchLogo();
    this.fetchPages();
    this.scrollToTop();
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0,0);
    },

    opnPopular(slug) {
      this.$router.push({ name: "show-popular-search", params:{slug: slug }});
      // refersh
      location.reload();
    },

    fetchLogo() {
      // Get Navbar Links
      axios
        .get(window.baseURL + "/setting")
        .then((res) => {
          var data = res.data;
          this.logo = res.data.logo;
          this.socials = res.data.social;
          this.header = res.data.header;
          console.log(data);
        })
        .catch(() => {});
    },


    //Get Navbar Links in Big Sizes
    fetchPages(){
    axios
      .get(window.baseURL + "/pages")
      .then((res) => {
        var data = res.data.rows;
        this.pages = res.data.rows;
      })
      .catch(() => {});
    },

    logout(){
      localStorage.clear();
      this.$router.push({ name: 'login' });
    },

  },
  mounted() {

  }
};
</script>
